import appGlobalScript from '/home/circleci/project/bam-scripts/src/global/global.ts';
export const globalScripts = appGlobalScript;
